import { UPDATE_TICKET_CATEGORIES } from "../actionTypes";
import { updateState } from "../utils";

const initialState = {
    categories: null,
};

const updateCategories = (state, action) => {
    return updateState(state, {
        categories: action.categories
    })
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_TICKET_CATEGORIES:
            return updateCategories(state, action);
        default:
            return state;
    }
}

export default reducer;